/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ApplicationRef,
  ContentChild,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomerCaseService, ProductService, UserProductService } from "../../../api";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";

@Component({
  selector: "create-new-bike",
  templateUrl: "./myBike.component.html"
})
export class MyBikeComponent implements OnInit {
  @ViewChild("addr") public searchElement: ElementRef;
  @ContentChild(CustomdatepickerComponent)
  datepickerViewChild: CustomdatepickerComponent;
  caseForm: FormGroup;
  products = [];
  shopList = [];
  brandList = [];
  categoryList = [];
  purchasedPlaces;
  productsByBrand = [];
  productById
  today = new Date();
  minDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  isLoading = false;
  constructor(
    public activeModal: NgbActiveModal,
    private app: ApplicationRef,
    private ccs: CustomerCaseService,
    private ups: UserProductService,
    private ps: ProductService
  ) {}

  ngOnInit() {
    this.ups
      .apiUserProductsBrandCategoryProductSelectGet()
      .subscribe((data) => {
        this.brandList = data.brandRepairshops;
        this.categoryList = data.categories;
        this.products = data.products;
        console.log(data);
      });
    this.caseForm = new FormGroup({
      brand: new FormControl(null, [Validators.required]),
      categories: new FormControl(null, [Validators.required]),
      product: new FormControl(null, [Validators.required]),
      stelnummer: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^W/),
      ]),
      shop: new FormControl(null, [Validators.required]),
      time: new FormControl(this.minDate, [Validators.required]),
    });
  }

  get brand() {
    return this.caseForm.get("brand");
  }
  get categories() {
    return this.caseForm.get("categories");
  }
  get product() {
    return this.caseForm.get("product");
  }
  get stelnummer() {
    return this.caseForm.get("stelnummer");
  }
  get time() {
    return this.caseForm.get("time");
  }
  get shop() {
    return this.caseForm.get("shop");
  }
  validateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
      this.app.tick();
    });
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  handleChangeProduct(){
    this.ps
    .apiProductsByProductIdGet(this.product.value)
    .subscribe((data) => {
      this.productById = data
      console.log(this.productById)
    });
  }
  handleChangeBrand() {
    const selectedBrandId = this.brand.value;
    const selectedBrandPlaces = this.brandList.find(
      (place) => place.brandId === selectedBrandId
    );
  
    // Chỉ reset Repair Shop
    this.caseForm.patchValue({
      shop: null
    });
  
    // Reset purchasedPlaces
    this.purchasedPlaces = [];
  
    if (selectedBrandPlaces) {
      this.purchasedPlaces = selectedBrandPlaces.purchasedPlaces || [];
    }
  
    this.productsByBrand = this.products.filter(
      (product) => product.brandId === selectedBrandId
    );
  }
  
  

  saveModal() {
    if (this.caseForm.valid) {
      if (!this.isLoading) {
        this.isLoading = true;
        const day = this.time.value.day;
        const month = this.time.value.month;
        const year = this.time.value.year;
        const timeUnixTimestamp = Math.floor(
          new Date(year, month - 1, day).getTime() / 1000
        );
        const dataRepuest = {
          productName : this.productById.name,
          productBrandId : this.brand.value,
          productCategoryId: this.productById.categoryId,
          productWarrantyPeriod: this.productById.warrantyPeriod,
          customerId: undefined,
          productId: this.product.value,
          productProductId: this.productById.productId,
          productBrandBrandId: this.productById.brandId,
          productBrandName: undefined,
          productBrandIsActive: undefined,
          productPhoto: undefined,
          productItemNumber:  new Date().getTime() +
          ' ' +
          (Math.random() + 1).toString(36).substring(7),
          productType: 2,
          productYear: undefined,
          productHidding: undefined,
          categoryId: this.categories.value,
          frameNumber: this.stelnummer.value,
          serialNumber: '',
          billDateTick: timeUnixTimestamp,
          billNumber: undefined,
          purchasedPlaceId: this.shop.value,
          billPhoto: undefined,
          framePhotos: undefined,
          serialPhotos: undefined,
          isCancelled: undefined,
          userProductId: undefined,
          batteryNumber: undefined,
          type: 2,
          bikeType: 2,
          photoUrl: undefined,
          caseId: undefined,
          isHaveOpenCase: undefined
        }
       
        this.ups     
          .apiUserProductsPostWithForm(
            dataRepuest.productName,
            dataRepuest.productBrandId,
            dataRepuest.productCategoryId,
            dataRepuest.productWarrantyPeriod,
            dataRepuest.customerId,
            dataRepuest.productId,
            dataRepuest.productProductId,
            dataRepuest.productBrandBrandId,
            dataRepuest.productBrandName,
            dataRepuest.productBrandIsActive,
            dataRepuest.productPhoto,
            dataRepuest.productItemNumber,
            dataRepuest.productType,
            dataRepuest.productYear,
            dataRepuest.productHidding,
            dataRepuest.categoryId,
            dataRepuest.frameNumber,
            dataRepuest.serialNumber,
            dataRepuest.billDateTick,
            dataRepuest.billNumber,
            dataRepuest.purchasedPlaceId,
            dataRepuest.billPhoto,
            dataRepuest.framePhotos,
            dataRepuest.serialPhotos,
            dataRepuest.isCancelled,
            dataRepuest.userProductId,
            dataRepuest.batteryNumber,
            dataRepuest.type,
            dataRepuest.bikeType,
            dataRepuest.photoUrl,
            dataRepuest.caseId,
            dataRepuest.isHaveOpenCase,
          )
          .subscribe(
            () => {
              this.activeModal.close();
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
              console.error("Error:", error);
            }
          );
      }
    } else {
      this.validateForm(this.caseForm);
    }
  }
}
